export default function ListIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="10"
      viewBox="0 0 12 10"
      fill="none"
    >
      <path
        d="M4.00038 9H11.5M0.500384 9H1.5M4.00038 5H11.5M0.500384 5H1.5M4 1H11.5M0.5 1H1.5"
        stroke="#5E718D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
